var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalCreationFormSubmissionFunnel = (function(superClass) {
  utils.extend(ModalCreationFormSubmissionFunnel, superClass);

  function ModalCreationFormSubmissionFunnel() {
    return ModalCreationFormSubmissionFunnel.__super__.constructor.apply(this, arguments);
  }

  ModalCreationFormSubmissionFunnel.prototype.init = function() {
    this._reloadPlugins(this.$html);

    return ModalCreationFormSubmissionFunnel.__super__.init.apply(this, arguments);
  }

  ModalCreationFormSubmissionFunnel.prototype._reloadPlugins = function($view) {
    appCustomerSpace.LimitlessPlugins.initPlugins($view);
  };

  return ModalCreationFormSubmissionFunnel;

})(appCustomerSpace.Modal);
